import api from '../../api';
import _ from 'lodash';
import router from '../../router';
import Vue from 'vue';
const PAGINATION_LIMIT = 12;
const defaultQuery = {
  order_by: 'created_at',
  dir: 'desc',
  limit: 300,
};

const emptyPagination = null;

const initialSchema = {
  location: {
    id: 'location',
    enabled: true,
    validation: null,
    default: null,
    type: 'array',
    presentation: 'location',
    is_dynamic: false,
    options: null,
    title: 'search.location',
    group: 'search.group_row-1',
    required: false,
    update: false,
    has_children: false,
    has_parent: false,
    class: null,
    value: {
      address_components: [],
      formatted_address: 'USA',
      geometry: {
        location: { lat: '37.269999999999996', lng: '-116.27000000000001' },
        viewport: {
          south: '32.53',
          west: '-124.48',
          north: '42.01',
          east: '-108.06',
        },
      },
      place_id: null,
      south: '32.53',
      west: '-124.48',
      north: '42.01',
      east: '-108.06',
      zoom: '11',
    },
  },
  available_from: {
    id: 'available_from',
    enabled: true,
    validation: ['date_format:Y-m-d', 'after_or_equal:2019-08-14'],
    default: false,
    type: 'date',
    presentation: 'date',
    is_dynamic: true,
    options: null,
    title: 'search.available_from',
    group: 'search.group_row-1',
    required: false,
    update: false,
    has_children: false,
    has_parent: false,
    class: null,
    value: '2019-08-14',
  },
  property_type: {
    id: 'property_type',
    enabled: true,
    validation: null,
    default: null,
    type: 'string',
    presentation: 'select',
    is_dynamic: false,
    options: [
      {
        id: 'search.property_type_any',
        value: null,
        text: 'search.property_type_any',
      },
      {
        id: 'search.property_type_room',
        value: 'room',
        text: 'search.property_type_room',
      },
      {
        id: 'search.property_type_apartment',
        value: 'apartment',
        text: 'search.property_type_apartment',
      },
    ],
    title: 'search.property_type',
    group: 'search.group_row-1',
    required: false,
    update: false,
    has_children: false,
    has_parent: false,
    class: null,
    value: 'room',
  },
  occupants: {
    id: 'occupants',
    enabled: true,
    validation: null,
    default: true,
    type: 'integer',
    presentation: 'select',
    is_dynamic: false,
    options: [
      { id: 'search.occupants_0', value: 0, text: 'search.occupants_0' },
      { id: 'search.occupants_1', value: 1, text: 'search.occupants_1' },
      { id: 'search.occupants_2', value: 2, text: 'search.occupants_2' },
      { id: 'search.occupants_3', value: 3, text: 'search.occupants_3' },
      { id: 'search.occupants_4', value: 4, text: 'search.occupants_4' },
      { id: 'search.occupants_5', value: 5, text: 'search.occupants_5' },
      { id: 'search.occupants_6', value: 6, text: 'search.occupants_6' },
      { id: 'search.occupants_7', value: 7, text: 'search.occupants_7' },
      { id: 'search.occupants_8', value: 8, text: 'search.occupants_8' },
      { id: 'search.occupants_9', value: 9, text: 'search.occupants_9' },
    ],
    title: 'search.occupants',
    group: 'search.group_row-1',
    required: false,
    update: false,
    has_children: false,
    has_parent: false,
    class: null,
    value: null,
  },
};

const state = {
  // query: lastQuery ? lastQuery : defaultQuery,
  query: defaultQuery,
  schema: initialSchema,
  item: null,
  pagination: emptyPagination,
  filters: [],
  progress: {
    fetch: false,
    load: false,
    show: false,
    store: false,
    delete: false,
    recover: false,
    schema: false,
    favoriting: false,
    reserving: false,
  },
  pagination_page: 1,
};

const getters = {
  isLoading: (state) => (action) => {
    const target = state.target;
    return _.get(state, `progress.${action}`, false);
  },

  pagination: (state) => {
    const target = state.target;
    return _.get(state, `pagination`, null);
  },

  items: (state) => {
    const target = state.target;
    return _.get(state, `pagination.data`, []);
  },
  clusters: (state) => {
    return _.get(state, `pagination.meta.clustering`, []);
  },
  paginated_items: (state) => {
    let data = _.get(state, `pagination.data`, []);
    return data.slice(0, state.pagination_page * PAGINATION_LIMIT);
  },
  config: (state, getters, rootState, rootGetters) => (action) => {
    const target = state.target;
    return mapConfig(rootState.config.data, target, action);
  },
  filterValue: (state) => {
    return (id) => {
      const query = state.query;
      if (!query[id]) return null;

      return query[id];
    };
  },
};

const actions = {
  setQuery: function(context, params) {
    context.commit('handleSetQuery', params);
  },
  loadItems: function(context) {
    const page = context.state.pagination_page + 1;
    context.commit('handlePageChange', page);
  },
  setQueryParam: function(context, payload) {
    let params = _.cloneDeep(context.state.query);
    // for (const key in params) {
    //   let param = params[key];
    //   if (_.isArray(param) && payload[key] && payload[key].length > 0) {
    //     payload[key] = _.union(payload[key], param);
    //   }
    // }
    context.commit('handleSetQueryParam', payload);
  },

  resetQuery: function(context, params) {
    let reset = {
      ...defaultQuery,
      // available_from: (new Date()).toISOString().split('T')[0],
    };
    context.commit('handleSetQuery', reset);
  },
  resetFilters: function(context, params) {
    context.commit('handleResetFilters');
  },
  fetch: function(context) {
    const query = context.state.query;

    context.commit('handleLoadingStatus', {
      action: 'fetch',
      status: true,
    });

    api.advert
      .index(query)
      .then((response) => {
        context.commit('handlePaginationResults', response.data);
      })
      .catch((error) => {})
      .then(() => {
        context.commit('handleLoadingStatus', {
          action: 'fetch',
          status: false,
        });
      });
  },

  show: function(context, uuid) {
    const query = context.state.query;

    context.commit('handleLoadingStatus', {
      action: 'show',
      status: true,
    });

    api.advert
      .show(uuid, query)
      .then((response) => {
        context.commit('handleShow', response.data);
      })
      .catch((error) => {})
      .then(() => {
        context.commit('handleLoadingStatus', {
          action: 'show',
          status: false,
        });
      });
  },

  create: function(context, payload) {
    payload = { ...payload, action: 'create' };
    context.dispatch('createOrEdit', payload);
  },

  store: function(context) {
    // body...
  },

  edit: function(context, payload) {
    payload = { ...payload, action: 'edit' };
    context.dispatch('createOrEdit', payload);
  },

  update: function(context, uuid) {
    // body...
  },

  delete: function(context) {
    // body...
  },

  recover: function(context) {
    // body...
  },

  cancel: function(context, payload) {
    const target = _.get(payload, 'target', _.get(this.state, 'target'));
    context.commit('handleCancel', { target: target });
  },

  loadSchema: function(context) {
    const query = context.state.query;

    context.commit('handleLoadingStatus', {
      action: 'schema',
      status: true,
    });

    return api.advert
      .filter(query)
      .then((response) => {
        _.forEach(query, (value, key) => {
          if (value && response.data[key] && key != 'available_from' && key != 'location') {
            context.dispatch('updateFilter', response.data[key]);
          }
        });
        context.commit('handleSchemaLoaded', response.data);
      })
      .catch((error) => {})
      .then(() => {
        context.commit('handleLoadingStatus', {
          action: 'schema',
          status: false,
        });
      });
  },

  addToFavorites: function(context, uuid) {
    context.commit('handleLoadingStatus', {
      action: 'favoriting',
      status: uuid,
    });
    return api.advert
      .addToFavorites(uuid)
      .then((resonse) => {
        context.commit('handleUdpateItemFlag', { is_favorited: true });
        context.commit('handleUdpatePagingItemFlag', {
          uuid: uuid,
          key: 'is_favorited',
          value: true,
        });
      })
      .catch((error) => {})
      .then(() => {
        context.commit('handleLoadingStatus', {
          action: 'favoriting',
          status: false,
        });
      });
  },

  removeFromFavorites: function(context, uuid) {
    context.commit('handleLoadingStatus', {
      action: 'favoriting',
      status: uuid,
    });
    return api.advert
      .removeFromFavorites(uuid)
      .then((resonse) => {
        context.commit('handleUdpateItemFlag', { is_favorited: false });
        context.commit('handleUdpatePagingItemFlag', {
          uuid: uuid,
          key: 'is_favorited',
          value: false,
        });
      })
      .catch((error) => {})
      .then(() => {
        context.commit('handleLoadingStatus', {
          action: 'favoriting',
          status: false,
        });
      });
  },

  addToInteresting: function(context, uuid) {
    context.commit('handleLoadingStatus', {
      action: 'reserving',
      status: uuid,
    });
    return api.advert
      .addToInteresting(uuid)
      .then((resonse) => {
        context.commit('handleUdpateItemFlag', { is_reserved: true });
      })
      .catch((error) => {})
      .then(() => {
        context.commit('handleLoadingStatus', {
          action: 'reserving',
          status: false,
        });
      });
  },

  removeFromInteresting: function(context, uuid) {
    context.commit('handleLoadingStatus', {
      action: 'reserving',
      status: uuid,
    });
    return api.advert
      .removeFromInteresting(uuid)
      .then((resonse) => {
        context.commit('handleUdpateItemFlag', { is_reserved: false });
      })
      .catch((error) => {})
      .then(() => {
        context.commit('handleLoadingStatus', {
          action: 'reserving',
          status: false,
        });
      });
  },
  updateFilter: function(context, filter) {
    const filters = _.cloneDeep(context.state.filters);
    const index = _.findIndex(filters, { id: filter.id });
    if (index != -1) {
      filters.splice(index, 1, filter);
    } else {
      filters.push(filter);
    }
    context.commit('handleUpdateFilter', filters);
  },
  removeFilter: function(context, id) {
    const filters = _.cloneDeep(context.state.filters);
    const index = _.findIndex(filters, { id: id });
    if (index != -1) {
      filters.splice(index, 1);
    }
    context.commit('handleUpdateFilter', filters);
  },
};

const mutations = {
  handleSetQuery: function(state, data) {
    _.set(state, 'query', data);
  },
  handleResetFilters: function(state) {
    state.filters = [];
  },
  handlePageChange: function(state, page) {
    state.pagination_page = page;
  },
  handleSetQueryParam: function(state, payload) {
    state.query = Object.assign({}, state.query, payload);
  },

  handleLoadingStatus: function(state, { action, status }) {
    _.set(state, `progress.${action}`, status);
  },

  handleShow: function(state, data) {
    _.set(state, `item`, data);
  },

  handlePaginationResults: function(state, data) {
    _.set(state, `pagination`, data);
    state.pagination_page = 1;
  },

  handleSchemaLoaded: function(state, data) {
    _.set(state, `schema`, data);
  },

  handleCancel: function(state) {
    _.set(state, `item`, null);
  },

  handleEdit: function(state, { data }) {
    _.set(state, `item`, data);
  },

  handleUdpateItemFlag: function(state, payload) {
    state.item = Object.assign({}, state.item, payload);
  },

  handleUdpatePagingItemFlag: function(state, payload) {
    let pagination = _.get(state, 'pagination');
    let items = _.get(state, 'pagination.data', []);
    let index = _.findIndex(items, (e) => e.uuid == payload.uuid);
    if (index < 0) return;

    let item = Object.assign({}, items[index]);
    item[payload.key] = payload.value;

    pagination.data.splice(index, 1, item);
  },
  handleUpdateFilter: function(state, filters) {
    state.filters = filters;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
